// extracted by mini-css-extract-plugin
export var black = "mobile-nav-panel-module--black--0ubqV";
export var closeBtn = "mobile-nav-panel-module--close-btn--eFTn4";
export var closeIcon = "mobile-nav-panel-module--close-icon--8HQ5K";
export var container = "mobile-nav-panel-module--container--8kfxw";
export var header = "mobile-nav-panel-module--header--hD5ke";
export var logoBox = "mobile-nav-panel-module--logo-box--qeKt6";
export var logoWatermark = "mobile-nav-panel-module--logo-watermark--xuEQh";
export var navPanel = "mobile-nav-panel-module--nav-panel--CLU2j";
export var opened = "mobile-nav-panel-module--opened--Rs52b";